<template>
  <div class="locale_switcher">
    <select
      class="locale_switcher__select"
      :value="$i18n.locale"
      aria-label="Select language"
      @change="onChange"
    >
      <option v-for="loc in locales" :key="loc.value" :value="loc.value">
        {{ loc.label }}
      </option>
    </select>
    <svg
      class="locale_switcher__icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M4 6l4 4 4-4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { setLanguage } from '@/i18n'

@Component
export default class LocaleSwitcher extends Vue {
  readonly locales = [
    { value: 'ja', label: '日本語' },
    { value: 'en', label: 'English' },
    { value: 'zh-Hant', label: '繁體中文' },
    { value: 'ko', label: '한국어' },
  ]

  onChange(e: Event) {
    const lang = (e.target as HTMLSelectElement).value
    setLanguage(lang)
    const query = { ...this.$route.query, lang }
    this.$router.replace({ query }).catch(() => {})
  }
}
</script>

<style scoped>
.locale_switcher {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.locale_switcher__select {
  box-sizing: border-box;
  height: 32px;
  padding: 0 40px 0 16px;
  border: none;
  border-radius: 999px;
  outline: 1px solid #e8e8e8;
  outline-offset: -1px;
  background-color: #ffffff;
  color: #0f0f0f;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

.locale_switcher__icon {
  position: absolute;
  right: 12px;
  color: #0f0f0f;
  opacity: 0.5;
  pointer-events: none;
}
</style>
